// const keys for LocalStorage
export const AUTH_ACCESS_TOKEN = 'auth.accessToken';
export const AUTH_ID_TOKEN = 'auth.idToken';
export const AUTH_EXPIRATION_DATE = 'auth.expirationDate';
export const AUTH_DELEGATION_TOKEN = 'auth.delegation.token';
export const AUTH_DELEGATION_EXPIRY = 'auth.delegation.expiry';
export const WECHAT_OPENID = 'wechat.openid';
export const PROFILE_CACHE = 'auth.profile';

export const clearStorage = () => localStorage.clear();

export const getItemFromStorage = (key: string) => {
  if (!localStorage) return;

  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (err) {
    console.error(`Error getting item ${key} from localStorage`, err);
  }
};

export const getItem = (key: string, dftVal: string) => {
  if (!localStorage) return dftVal;
  return localStorage.getItem(key);
};

export const storeUserIdToken = (token: string) => {
  localStorage.setItem(AUTH_ID_TOKEN, token);
};

export const getUserIdToken = () => {
  if (window.top == window) {
    return getItem(AUTH_ID_TOKEN);
  }
  if (!window.xprops) {
    return;
  }
  const tokens = window.xprops.tokens || {};
  const { id_token } = tokens;
  storeUserIdToken(id_token);
  return id_token;
};

export const storeItem = (key: string, item: any) => {
  if (!localStorage) return;

  try {
    return localStorage.setItem(key, JSON.stringify(item));
  } catch (err) {
    console.error(`Error storing item ${key} to localStorage`, err);
  }
};

export const removeItemFromStorage = (key: string) => {
  if (!localStorage) return;

  try {
    return localStorage.removeItem(key);
  } catch (err) {
    console.error(`Error removing item ${key} from localStorage`, err);
  }
};
